const getBundleOptionsArray = (productData) => {

    return productData?.type_id === "bundle" ? productData?.items?.[0]?.options?.map(option => option.uid) : [];
}

export default getBundleOptionsArray;